export const SET_LOCATION_ON_CLOCK_IN = "SET_LOCATION_ON_CLOCK_IN";
export const CLEAR_LOCATION_ON_CLOCK_OUT = "CLEAR_LOCATION_ON_CLOCK_OUT";

export const setLocationOnClockIn = (latitude, longitude) => ({
  type: SET_LOCATION_ON_CLOCK_IN,
  payload: { latitude, longitude },
});

export const clearLocationOnClockOut = () => ({
  type: CLEAR_LOCATION_ON_CLOCK_OUT,
});

const initialState = {
  isClockIn: false,
  latitude: null,
  longitude: null,
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOCATION_ON_CLOCK_IN:
      return {
        ...state,
        isClockIn: true,
        latitude: action.payload.latitude,
        longitude: action.payload.longitude,
      };
    case CLEAR_LOCATION_ON_CLOCK_OUT:
      return {
        ...state,
        isClockIn: false,
        latitude: null,
        longitude: null,
      };
    default:
      return state;
  }
};

export default locationReducer;
